import { render, staticRenderFns } from "./TopicsList.vue?vue&type=template&id=4d3d448f&scoped=true"
import script from "./TopicsList.vue?vue&type=script&lang=js"
export * from "./TopicsList.vue?vue&type=script&lang=js"
import style0 from "./TopicsList.vue?vue&type=style&index=0&id=4d3d448f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3d448f",
  null
  
)

export default component.exports